import { Icon } from '../icon';
import { SearchInput } from '../input';
import _ from 'lodash';
import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import SearchIcon from 'src/shared/icons/search-solid.svg';
import styled from 'styled-components';
import theme from '../../../shared/theme';

export const InputToolBar = styled.input<InputProps>`
    color: ${theme.input.color};
    border: 1px ${theme.app.primary} solid;
    border-radius: 4px;
    padding: 5px 10px;
    font-family: ${theme.app.font};
    font-size: ${theme.input.textSize};
    height: 30px;

    &:focus,
    &:active {
        outline: none;
        border-color: ${theme.app.primary};
    }

    ${(props) => (props.fullWidth ? 'width: 100%;' : '')}
    ${(props) => (props.readOnly ? 'background-color: transparent;' : '')}
`;

const SearchInputContainerToolBar = styled.div`
    position: relative;

    ${Icon} {
        position: absolute;
        top: calc(50% - 12px);
        right: 10px;
        color: ${theme.app.primary};
    }
`;

interface InputProps {
    fullWidth?: boolean;
}

export const SearchInputToolBar: FunctionComponent<InputProps & React.ComponentProps<'input'> & { onSearch?: (filter: string) => void }> = (props) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.onChange) props.onChange(e);

        handleSearch(e.currentTarget.value);
    };

    const handleSearch = _.debounce((filter: string) => {
        if (props.onSearch) props.onSearch(filter);
    }, 400);

    return (
        <SearchInputContainerToolBar>
            <InputToolBar {..._.omit(props, ['onSearch', 'ref'])} onChange={handleChange} />
            <Icon>
                <SearchIcon />
            </Icon>
        </SearchInputContainerToolBar>
    );
};

export const SearchInputFindToolBar = styled(SearchInputToolBar)`
    border-radius: 30px;
    background-color: ${theme.app.backgroundToolbar};
    color: ${theme.app.primary};
    height: 30px;

    ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${theme.app.primary};
        opacity: 1; /* Firefox */
        font-weight: ${theme.font.regular};
    }
`;
//<<<<<<<<<<<

//Versione che eredita dall'oggetto originale
export const SearchInputFind = styled(SearchInput)`
    border-radius: 30px;
    background-color: ${theme.app.backgroundToolbar};
    color: ${theme.app.backgroundColor};
    height: 30px;

    ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${theme.app.backgroundColor};
        opacity: 1; /* Firefox */
        font-weight: ${theme.font.regular};
    }
`;

export const MainContainerToolbar = styled.div<{ $visitorMode?: boolean }>`
    background-color: ${(p) => (p.$visitorMode ? '#fff' : theme.app.backgroundToolbar)};
    ${(p) => p.$visitorMode && 'box-shadow:0px 2px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25);'}
    //margin-bottom: 62px;
	width: 100%;
    position: fixed;
    z-index: 19;
    top: 0;
    left: 0;
`;

export const ContainerToolbar = styled.div<{ $visitorMode?: boolean }>`
    align-items: center;
    display: flex;
    height: ${(p) => (p.$visitorMode ? '53px' : '55px')};
    justify-content: space-between;
    position: relative;
    color: ${theme.app.primary};
    font-family: ${theme.app.font};
    font-weight: ${theme.font.regular};
    font-size: 14px;
    padding: 0 24px;
    ${(p) => p.$visitorMode && 'max-width: 1266px; margin:0 auto; padding: 0 20px;'}

    @media screen and (max-width:900px) {
        padding: 0 20px;
    }
`;

export const IconFinf = styled(Icon)``;

export const ContainerLogo = styled.div`
    margin-left: 0;
    /* margin-right: 140px; */
    margin-right: 10px;
    width: 180px;

    > svg {
        height: 44px;
        width: 140px;
    }
`;

export const LinkLogo = styled.a`
    > svg {
        height: 44px;
        width: 140px;
    }
`;

export const MenuLeft = styled.div`
    display: flex;
    justify-content: space-around;
    height: 24px;
    align-items: center;
`;

export const MenuRight = styled.div<{ $visitorMode: boolean }>`
    ${(p) => !p.$visitorMode && 'margin: 0 100px 0 auto;'}
    display: flex;
    justify-content: space-around;
    height: 24px;
    align-items: center;
    @media screen and (min-width: 1025px) and (max-width: 1500px) {
        ${(p) => p.$visitorMode && 'margin: 0 100px 0 auto;'}
    }
`;

export const MenuItem = styled.div`
    display: flex;
    position: relative;
`;

export const MenuItemDefault = styled.div<{ $padding?: string }>`
    /* display: inline;  */
    ${(props) => (props.$padding ? 'padding: ' + props.$padding + ';' : '')}
    cursor: pointer;

    color: ${theme.app.primary};
    font-family: ${theme.app.font};
    font-weight: ${theme.font.regular};
    font-size: 14px;
`;

export const MenuItemStrong = styled.div`
    display: inline;
    padding: 0 10px;
    cursor: pointer;

    color: ${theme.app.secondary};
    font-family: ${theme.app.font};
    font-weight: ${theme.font.bold};
    font-size: 14px;

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const NoWrap = styled(MenuItemDefault)`
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const IconMenuContainer = styled.div`
    margin-right: 10px;

    ${Icon} {
        width: 25px;
        height: 25px;
    }
`;

export const ContainerText = styled.div`
    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

export const SeparatorMenu = styled.div`
    width: 1px;
    height: 24px;
    background-color: ${theme.app.primary_light}; /* #dfe5eb; */
    align-self: center;
    margin-left: 9px;
    margin-right: 6px;
`;

export const InputToolbar = styled.input`
    flex-grow: 1;
    flex-shrink: 1;
    min-width: 24px;
    padding: 6px;
    margin: 0;
    border: 0;
    outline: 0;
    line-height: 1.5;
    background: transparent;
    box-shadow: none;
    border-radius: 6px;

    background-color: #eaf7ff !important;
    border-radius: 15px;
    margin: 3px 0;
    height: 30px;
    font-size: 14px;

    /* display: flex; */
    width: 100%;
    padding: 0 6px;
`;

// PopUp Result <<<
export const ContanierResultMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: 46px;
    right: 0px;

    width: 448px;
    /* height: 597px; */
    height: 613px;

    ${(props) => (props.$isVisible ? null : 'display: none')};

    padding: 4px 5px;
    background-color: ${theme.app.backgroundColor};
    /* box-shadow: 0px 0px 10px rgba(0,0,0,0.1); */

    -webkit-border-radius: 10px;
    border-radius: 10px;

    -webkit-box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
`;

export const ItemResultList = styled.div<{ height?: string }>`
    padding: 5px;
    overflow-y: auto;
    ${(props) => (props.height ? 'height: ' + props.height + ';' : 'height: 262px;')}
    margin-bottom: 5px;

    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${theme.app.secondary}; /* theme.app.primary_light    */
        border-radius: 20px;
    }
    scrollbar-color: ${theme.app.secondary} ${theme.app.backgroundColor};
    scrollbar-width: thin;
    background-color: ${theme.app.backgroundColorBase};
`;

export const ItemResultTitle = styled.div<{ height?: string }>`
    padding: 5px;
    ${(props) => (props.height ? 'height: ' + props.height + ';' : 'height: 34px;')}

    color: ${theme.app.primary};
    font-family: ${theme.app.font};
    font-size: 14px;
    font-weight: ${theme.font.regular};
    text-transform: uppercase;
`;

export const ItemResultListError = styled.div<{ height?: string }>`
    padding: 100px 5px;
    overflow-y: auto;
    ${(props) => (props.height ? 'height: ' + props.height + ';' : 'height: 284px;')}

    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${theme.app.primary_light}; /* #E2E3E4; */
        border-radius: 20px;
    }

    scrollbar-color: ${theme.app.primary_light} ${theme.app.backgroundColor};
    scrollbar-width: thin;

    background-color: ${theme.app.backgroundColorBase};
`;

export const LinkResultMenu = styled.a<{ $isHeader?: boolean }>`
    padding: 6px 5px;
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.app.primary};
    font-family: ${theme.app.font};

    ${(props) => (props.$isHeader ? `font-weight: ${theme.font.black};` : `font-weight: ${theme.font.regular};`)};
    ${(props) => (props.$isHeader ? `font-size: 15px;` : `font-size: 14px;`)};
    ${(props) => (props.$isHeader ? `text-transform: uppercase;` : null)};
    ${(props) => (props.$isHeader ? 'min-height: 55px;' : 'min-height: 25px;')};
    ${(props) => (props.$isHeader ? 'padding-bottom: 30px;' : null)};
    ${(props) => (props.$isHeader ? 'cursor: default;' : 'cursor: pointer;')};

    :hover {
        background: #fae2c0;
    }
`;

// Prima ereditava da FormControl di globals.tsx
export const FindContainer = styled.div`
    max-width: 450px;
    min-width: 250px;
    width: 20vw;

    & svg {
        fill: ${theme.app.primary};
    }
`;

export const SwitchComposer = styled.div`
    position: relative;

    /* border: solid 1px ${theme.app.secondary_dark}; */
    border-radius: 30px;
    /* padding: 7px 40px; */
    padding: 7px 38px 7px 17px;
    text-transform: uppercase;
    justify-content: center;
    cursor: pointer;

    background-color: ${theme.app.backgroundToolbar};
    color: ${theme.app.secondary_dark};

    font-family: ${theme.app.font};
    font-weight: ${theme.font.extra_bold};
    font-size: 12px;

    /* overflow: hidden; */
    text-overflow: ellipsis;
    white-space: nowrap;
    /* width: 14vw; */
`;

export const SendAMessage = styled.div`
    text-align: center;
    position: relative;

    border: none;
    border-radius: 30px;
    padding: 10px 40px;
    text-transform: uppercase;
    justify-content: center;
    cursor: pointer;

    background-color: ${theme.app.highlighted};
    color: ${theme.app.backgroundColorBase};
    font-family: ${theme.app.font};
    font-weight: ${theme.font.bold};
    font-size: 14px;
`;

export const ImgArrowRight = styled.div`
    width: 20px;
    height: 20px;
    padding-left: 8px;
    padding-right: 13px;
    position: absolute;
    top: calc(50% - 6px);
    right: 18px;
    > svg {
        fill: ${theme.app.secondary_dark};
    }
`;

export const ImgIcon = styled.div`
    position: relative;
    width: 26px;
    height: 26px;
    margin: 0 13px;
    cursor: pointer;
    pointer-events: bounding-box;

    > svg {
        fill: ${theme.app.primary};
    }

    :hover {
        opacity: 0.7;
    }

    &.grayed {
        svg {
            opacity: 0.4;
        }
    }
`;

export const ImgIconUser = styled(ImgIcon)`
    margin-right: 0px;
`;

export const ImgIconLogout = styled(ImgIcon)`
    margin: 0 5px;
`;

export const MenuItemIcon = styled(ImgIcon)<{ $isDark?: boolean }>`
    margin: 0px;
    width: 18px;
    height: 18px;
    margin-right: 0px;

    > svg {
        ${(props) => (props.$isDark ? 'fill: ' + theme.app.secondary + ';' : null)}
    }
`;

export const ArrowToolContainer = styled.div`
    margin-top: 6px;
`;

export const PopupArrow = styled.div`
    position: absolute;
    top: -10px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid ${theme.app.backgroundColorBase};
`;

// PopUp UserMenu
export const PopupContainer = styled.div<{ $width?: number; $align: 'left' | 'right' }>`
    position: absolute;
    top: 40px;
    z-index: 99999;

    ${(props) =>
        props.$align === 'right' &&
        `
        right: 0;

        ${PopupArrow} {
            right: 10px;
        }
    `};

    ${(props) =>
        props.$align === 'left' &&
        `
        left: 0;

        ${PopupArrow} {
            left: 10px;
        }
    `};

    min-width: 250px;
    width: ${(props) => (props.$width ? props.$width + 'px' : '100%')};
    max-width: 400px;
    max-height: 283px;

    padding: 10px;
    background-color: ${theme.app.backgroundColorBase};
    /* box-shadow: 0px 0px 10px rgba(0,0,0,0.1); */

    -webkit-border-radius: 10px;
    border-radius: 10px;

    -webkit-box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
`;

export const PopupMenuItem = styled.a<{ $isHeader?: boolean }>`
    padding: 5px;
    margin: 2px;
    display: flex;
    word-break: keep-all;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.app.primary};
    font-family: ${theme.app.font};

    ${(props) => (props.$isHeader ? `font-weight: ${theme.font.black};` : `font-weight: ${theme.font.regular};`)};
    ${(props) => (props.$isHeader ? `font-size: 14px;` : `font-size: 13px;`)};
    ${(props) => (props.$isHeader ? `text-transform: uppercase;` : null)};
    ${(props) => (props.$isHeader ? 'min-height: 55px;' : 'min-height: 25px;')};
    ${(props) => (props.$isHeader ? 'padding-bottom: 30px;' : null)};
    ${(props) => (props.$isHeader ? 'cursor: default;' : 'cursor: pointer;')};

    // Max two lines with vertical overflow

    overflow: hidden;

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

export const PopupMenuItemIcon = styled.div`
    width: 30px;
    height: 20px;

    min-width: 30px;
    min-height: 20px;
    padding-right: 10px;
    padding-left: 0px;

    > svg {
        fill: ${theme.app.primary};
    }
`;

export const PopupMenuItemLarge = styled.a`
    margin: 2px;
    padding: 10px 15px;
    text-decoration: none;
    cursor: pointer;
    pointer-events: auto;
    color: ${theme.app.primary};
    font-family: ${theme.app.font};
    border-radius: 10px;
    display: grid;
    grid-template-areas:
        'icon title'
        'icon subtitle';
    grid-template-columns: 48px 1fr;
    grid-gap: 5px;

    &:hover {
        background-color: #f1f1f1;
    }

    > strong {
        display: block;
        font-size: 14px;
        font-weight: 500;
        grid-area: title;
    }

    > span {
        display: block;
        font-size: 10px;
        grid-area: subtitle;
    }
`;

export const PopupMenuItemLargeIcon = styled.div`
    grid-area: icon;
    width: 40px;
    height: 40px;
    border-radius: 5px;

    ${Icon} {
        width: 100%;
        height: 100%;
    }
`;

export const PopupMenuItemLargeNewProduct = styled.span`
    padding: 5px 10px;
    background-color: #d6f3e2;
    color: #086343;
    font-size: 10px;
    border-radius: 3px;
    font-weight: normal;
    display: inline-block;
    margin-left: 10px;
`;

export const PopupMenuMiddle = styled.div`
    & > :first-child {
        padding-top: 20px;
    }

    & > :last-child {
        padding-top: 10px;
        padding-bottom: 20px;
    }
`;

// PopUp LanguageMenu
export const ContanierLanguageMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: 44px;
    right: -130px;
    width: 250px;
    height: 230px;
    z-index: 2;

    padding: 25px;
    background-color: ${theme.app.backgroundColorBase};

    ${(props) => (props.$isVisible ? null : 'display: none')};

    -webkit-border-radius: 10px;
    border-radius: 10px;

    -webkit-box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
`;

export const TriangleLanguageMenu = styled.div`
    position: absolute;
    top: -10px;
    right: 140px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;

    border-bottom: 15px solid ${theme.app.backgroundColorBase};
`;

export const ItemLanguagePopupMenu = styled.div`
    padding: 5px;
    overflow-y: auto;
    height: 180px;

    ::-webkit-scrollbar {
        width: 3px;
    }
    ::-webkit-scrollbar-track {
        background: ${theme.app.backgroundColor};
        border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
        background: ${theme.app.secondary}; /* theme.app.primary_light */
        border-radius: 20px;
    }
    scrollbar-color: ${theme.app.secondary} ${theme.app.backgroundColor};
    scrollbar-width: thin;
`;

export const ContainerNotification = styled.div`
    position: absolute;
    top: -10px;
    left: 3px;
`;

//Social Menu
export const ContanierSocialMenu = styled.div<{ $isVisible: boolean }>`
    position: absolute;
    top: 40px;
    left: -32px;
    width: 180px;
    height: 180px;
    z-index: 2;

    background-color: ${theme.app.backgroundColorBase};
    padding: 20px;

    ${(props) => (props.$isVisible ? null : 'display: none')};

    -webkit-border-radius: 10px;
    border-radius: 10px;

    -webkit-box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 110px 3000px rgba(0, 0, 0, 0.4);
`;

export const ItemSocialMenu = styled.div`
    padding: 5px;
`;

export const TriangleSocialMenu = styled.div`
    position: absolute;
    top: -10px;
    right: 34px;
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;

    border-bottom: 15px solid ${theme.app.backgroundColorBase};
`;

export const ContainerSendMessage = styled.div`
    padding: 15px 25px;
    background-color: ${theme.app.backgroundColor};
`;

export const ImgIconNotFound = styled.div`
    position: relative;

    width: 170px;
    height: 170px;
    margin: 15px auto;
    > svg {
        fill: ${theme.app.primary_light};
    }
`;

export const Message = styled.div<{ isBold?: boolean; padding?: string }>`
    ${(props) => (props.padding ? 'padding: ' + props.padding + ';' : '')}

    color: ${theme.app.primary};
    font-family: ${theme.app.font};
    font-size: 14px;
    text-align: center;
    cursor: default;
    ${(props) => (props.isBold ? `font-weight: ${theme.font.black};` : `font-weight: ${theme.font.regular};`)};
`;

export const LinkOtherResults = styled.a<{ isHeader?: boolean }>`
    padding: 5px 5px 10px 5px;
    margin: 2px;
    display: flex;
    align-items: center;
    justify-content: left;
    text-decoration: none;
    cursor: pointer;
    color: ${theme.app.secondary};
    font-family: ${theme.app.font};
    font-size: 12px;
    font-weight: ${theme.font.black};

    :hover {
        filter: alpha(opacity=70);
        opacity: 0.7;
    }
`;

export const ContainerHelpGuides = styled.div`
    display: flex;
    justify-content: space-between;
`;

// Buttons header for non registered users
export const ButtonsHeaderVisitor = styled.div`
    a {
        margin-left: 15px;
    }
    @media screen and (max-width: 900px) {
        a {
            margin: 0;
            font-size: 12px;
            &.StartFreeTrial {
                display: none;
            }
        }
    }
`;

export const HelpWidgetContainer = styled.div`
    width: 45px;
    height: 45px;
    position: fixed;
    right: 0;
    top: 0;
    background-color: pink;
`;

//Menu Account
export const MenuAccountContainer = styled.div<{ $width?: number; $align: 'left' | 'right' }>`
    position: absolute;
    top: 40px;
    width: 330px;
    /* max-height: 560px; */
    overflow-y: auto;
    z-index: 10000;
    background-color: ${theme.app.backgroundColorBase};
    border-radius: 10px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

    ${(props) =>
        props.$align === 'right' &&
        `
        right: 0;

        ${PopupArrow} {
            right: 10px;
        }
    `}

    ${(props) =>
        props.$align === 'left' &&
        `
        left: 0;

        ${PopupArrow} {
            left: 10px;
        }
    `}

	&::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: transparent;
        margin-right: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background: rgba(207, 216, 220);
        border-radius: 10px;
        transition: background 0.3s ease;
    }

    &:not(:hover)::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0);
    }
`;

export const ItemAccountMenuContainer = styled.a<{ hasDashedLine?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 10px 20px;
    border-radius: 4px;
    transition: background-color 0.2s;
    text-decoration: none;
    position: relative;
    flex-shrink: 0;
    width: auto;
    max-width: none;
    background-color: #ffffff;

    &::after {
        content: '';
        display: ${(props) => (props.hasDashedLine ? 'block' : 'none')};
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        border-bottom: 1px solid #f3f5f6;
    }

    &:hover {
        cursor: pointer;
        filter: alpha(opacity=70);
        opacity: 0.7;
        width: auto;
    }
`;

export const MenuTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: auto;
    flex: 1;
    white-space: nowrap;
`;

export const IconItemMenu = styled.div`
    display: flex;
    align-items: top;
    justify-content: center;
    text-align: center;
    background-color: #ffffff;
    width: 36px;
    height: 36px;
    margin-right: 12px;
    flex-shrink: 0;
    cursor: pointer;
    color: #ffffff;
    padding: 0;
    box-sizing: border-box;
`;

export const MenuTitle = styled.div<{ titleCss?: React.CSSProperties; titleHoverCss?: React.CSSProperties }>`
    font-weight: normal;
    font-size: 14px;
    color: #000;
    ${(props) => props.titleCss && { ...props.titleCss }}
    text-decoration: none;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;

    &:hover {
        ${(props) => props.titleHoverCss && { ...props.titleHoverCss }}
    }
`;

export const MenuDescription = styled.div<{ descriptionCss?: React.CSSProperties }>`
    font-size: 12px;
    color: #445a64;
    margin-top: 2px;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
    ${(props) => props.descriptionCss && { ...props.descriptionCss }}
`;

export const FooterMenu = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background-color: #fafbfb;
    padding: 8px 20px;
    font-size: 10px;
    color: #445a64;
    white-space: nowrap;
    text-align: center;
    border-radius: 0 0 8px 8px;

    a {
        text-decoration: none;
        color: ${theme.app.primary};
        font-size: 12px;

        &:hover {
            text-decoration: underline;
        }
    }
`;

interface AccountMenuItemProps {
    icon?: React.ReactNode;
    title: string;
    description?: string;
    href?: string;
    onClick?: () => void;
    titleCss?: React.CSSProperties;
    titleHoverCss?: React.CSSProperties;
    descriptionCss?: React.CSSProperties;
    hasDashedLine?: boolean;
}

export const AccountMenuItem: React.FC<AccountMenuItemProps> = ({
    icon,
    title,
    description,
    href,
    onClick,
    titleCss,
    titleHoverCss,
    descriptionCss,
    hasDashedLine = false
}) => {
    return (
        <ItemAccountMenuContainer
            as={href ? 'a' : 'div'}
            href={href || undefined}
            onClick={onClick}
            target={href?.startsWith('http') ? '_blank' : undefined}
            rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
            hasDashedLine={hasDashedLine}
        >
            {icon && <IconItemMenu>{icon}</IconItemMenu>}
            <MenuTitleContainer>
                <MenuTitle titleCss={titleCss} titleHoverCss={titleHoverCss}>
                    {title}
                </MenuTitle>
                {description && <MenuDescription descriptionCss={descriptionCss}>{description}</MenuDescription>}
            </MenuTitleContainer>
        </ItemAccountMenuContainer>
    );
};

// Overlay scuro per il dropdown portal
const DropdownOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 99998;
    pointer-events: none;
`;

// Styled component for portal popup
const PortalPopupContainer = styled.div.attrs({ className: 'tool-dropdown-popup' })<{ $width?: number; $align: 'left' | 'right'; $top: number; $left: number }>`
    position: fixed;
    top: ${(props) => props.$top}px;
    left: ${(props) => props.$left}px;
    z-index: 99999; /* Sopra l'overlay */

    min-width: 250px;
    width: ${(props) => (props.$width ? props.$width + 'px' : '100%')};
    max-width: 400px;
    max-height: 383px;

    padding: 10px;
    background-color: ${theme.app.backgroundColorBase};

    -webkit-border-radius: 10px;
    border-radius: 10px;

    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    pointer-events: auto;
`;

// Portal wrapper component for dropdown menus
interface ToolDropdownPortalProps {
    isVisible: boolean;
    triggerRef: React.RefObject<HTMLElement>;
    $width?: number;
    $align: 'left' | 'right';
    children: React.ReactNode;
    onClose?: () => void;
}

export const ToolDropdownPortal: React.FC<ToolDropdownPortalProps> = ({ isVisible, triggerRef, $width, $align, children, onClose }) => {
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const node = dropdownRef.current;
        if (!node) return;

        const stopEvent = (e: MouseEvent) => {
            // Blocca l'evento prima che arrivi al listener globale
            e.stopPropagation();
            e.stopImmediatePropagation();
        };

        node.addEventListener('click', stopEvent, true); // true = capture phase
        return () => {
            node.removeEventListener('click', stopEvent, true);
        };
    }, [dropdownRef]);

    useEffect(() => {
        if (isVisible && triggerRef.current) {
            const rect = triggerRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + 5,
                left: $align === 'left' ? rect.left : rect.right - ($width || 250)
            });
        }
    }, [isVisible, $align, $width]);

    // Handle click on overlay to close dropdown
    const handleOverlayClick = (event: React.MouseEvent) => {
        console.log('handleOverlayClick clicked');
        if (onClose) {
            // event.stopPropagation();
            onClose();
        }
    };

    if (!isVisible) return null;

    return createPortal(
        <>
            <DropdownOverlay onClick={handleOverlayClick} />
            <PortalPopupContainer
                ref={dropdownRef}
                $width={$width}
                $align={$align}
                $top={position.top}
                $left={position.left}
                onClick={(e) => e.stopPropagation()}
            >
                <PopupArrow />
                {children}
            </PortalPopupContainer>
        </>,
        document.body
    );
};
